export default (selectors, callback) => {
  /* eslint-disable no-undef */
  if (!Modernizr.intersectionobserver) {
    return;
  }
  /**
   * Add class when elements comes into view
   * @type {IntersectionObserver}
   */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if ('function' === typeof callback) {
          callback(entry.target);
        }
        // Improve performance by removing observe on this element
        observer.unobserve(entry.target);
      }
    });
  });

  let elements = document.querySelectorAll(selectors);

  for (let i = 0; i < elements.length; i++) {
    observer.observe(elements[i]);
  }
}
